import React, { useState, useEffect } from 'react';
import { useAuth } from '../../../../../../../context/AuthContext';
import { useParams } from 'react-router-dom';
import Swal from 'sweetalert2'
import { useNavigate } from "react-router-dom";
import GeneralRequestHelper from '../../../../../../../Helpers/GeneralRequestHelper';
import SubmitButton from '../UI/SubmitButton';
import InfoInput from '../UI/InfoInput';
import CorrectAnswer from '../UI/CorrectAnswer';
import QuestionTextInput from '../UI/QuestionTextInput';
import AddContentQuestion from '../UI/AddContentQuestion';
import Tag from '../UI/Tag';
import TitleArea from '../UI/TitleArea';
import QuestionTitleInput from '../UI/QuestionTitleInput';

import AnswerForm from '../UI/AnswerForm';
const Choice = (props) => {
    const { user } = useAuth();
    const params = useParams()
    const navigate = useNavigate();
    const [msg, setMsg] = useState([]);
    const [serviceList, setServiceList] = useState([{ service: "" }]);
    const [imagePath, setImagePath] = useState(null);
    const [videoPath, setVideoPath] = useState(null);
    const [soundPath, setSoundPath] = useState(null);


    const handletype2 = async (e) => {
        e.preventDefault();
        if (document.getElementById("tagId").value === "Tür Seçiniz") {
            alert("Tür Seçmediniz.")
            return false;
        }
        var x = document.getElementById("correctAnswer").value;

        let answer = Number(x) - 1;
        let question;
        let questiontitle = document.getElementById("questionTitle").value.trim() || " ";
        let que = document.getElementById("questionText").value.trim() || " ";
        let questiontext = questiontitle + "__" + que;

        // YENİ MANTIK: Öncelik "Resim + Ses" kombinasyonunda
        if (imagePath && soundPath) {
            question = {
                type: "image_sound", // İstediğin yeni tip
                url: imagePath,      // Resim URL'i
                soundUrl: soundPath, // Ses URL'i (API'nin karşılaması için yeni alan)
                text: questiontext
            };
        }
        else if (imagePath) {
            question = {
                type: "image",
                url: imagePath,
                text: questiontext
            };
        }
        else if (soundPath) {
            question = {
                type: "sound",
                url: soundPath,
                text: questiontext
            };
        }
        else if (videoPath) {
            question = {
                type: "video",
                url: videoPath,
                text: questiontext
            };
        }
        else {
            question = {
                type: "text",
                url: "",
                text: questiontext
            };
        }

        var stringquestion = JSON.stringify(question);
        var info = document.getElementById("infoBoxText").value;
        try {
            const data = {
                isDeleted: false,
                tagId: document.getElementById("tagId").value,
                sortId: params["sort"],
                contentType: "choice",
                subjectId: params["subject"],
                contentStr: stringquestion,
                detail: JSON.stringify(serviceList),
                notfyText: info,
                answer: answer.toString()
            };
            await GeneralRequestHelper("/api/admin/ContentManager/Create", "post", data, user.token).then(res => {
                if (res.status === 200) {
                    if (res.data['success']) {
                        Swal.fire({
                            title: "Başırılı!",
                            icon: "success",
                            confirmButtonText: `Soru ekleme sayfasına Dön`,
                            showDenyButton: true,
                            denyButtonText: `Aynı konuya bir soru daha ekle`,
                        }).then((result) => {
                            if (result.isConfirmed) {
                                navigate("/admin/createquestion");
                            } else if (result.isDenied) {
                                navigate("/admin/createquestionbysubject/" + params["subject"]);
                            }
                        });
                    }
                    else {
                        setMsg(res.data['message']);
                    }
                }
                else {
                    setMsg("Beklenmedik Bir Hata Oluştu. Tekrar Deneyiniz.");
                }
            });
        } catch (err) {
            alert(err.message)
            setMsg(err.message);
        }
    }

    useEffect(() => {
        alert("here")
    }, [])

    return (
        <div>
            <TitleArea msg={msg} text={"Çoktan Seçmeli Oluşturma Sayfası"} />
            <Tag />
            <AddContentQuestion
                setMsg={setMsg}
                setImagePath={setImagePath}
                setVideoPath={setVideoPath}
                setSoundPath={setSoundPath}
                imagePath={imagePath}   // Eklendi
                videoPath={videoPath}   // Eklendi
                soundPath={soundPath}   // Eklendi
            />            <hr />
            <form onSubmit={handletype2} >
                <QuestionTitleInput />

                <QuestionTextInput />
                <CorrectAnswer text="1/2/3/4/5 olarak hangi seçenek olduğunu belirtiniz lütfen. (Cevap ekle kısmında ki eklenen kaçıncı cevap olduğununun sayısal değeri)" />
                <InfoInput />
                <AnswerForm setServiceList={setServiceList} serviceList={serviceList} file={true} />
                <SubmitButton />
            </form>
            <hr />
            <hr />

        </div>
    );
};

export default Choice;